// extracted by mini-css-extract-plugin
export default {"mainContainer":"Process_mainContainer__pbcev","container":"Process_container__REQ3b","circles":"Process_circles__jY3uf","connect":"Process_connect__DUG32"};